import gsap from 'gsap';

const initAudioEmbeds = (elements) => {

    const calculateTime = (secs) => {
        const minutes = Math.floor(secs / 60);
        const seconds = Math.floor(secs % 60);
        const returnedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
        return `${minutes}:${returnedSeconds}`;
    };

    elements.forEach((element) => {
        const btn = element.querySelector(".js-audio-btn");
        const audioFile = element.querySelector(".js-audio-el");
        const currentTimeContainer = element.querySelector(".js-audio-curr");
        const durationContainer = element.querySelector(".js-audio-dur");
        const seekSlider = element.querySelector(".js-audio-slider");
        const playIcon = element.querySelector(".js-audio-play-icon");
        const pauseIcon = element.querySelector(".js-audio-pause-icon");
        let playState = "play";
        let raf = null;

        //helper funcs
        const displayDuration = () => {
            durationContainer.textContent = calculateTime(audioFile.duration);
        };

        const setSliderMax = () => {
            seekSlider.max = Math.floor(audioFile.duration);
        };

        const whilePlaying = () => {
            seekSlider.value = Math.floor(audioFile.currentTime);
            currentTimeContainer.textContent = calculateTime(seekSlider.value);
            element.style.setProperty(
                "--seek-before-width",
                `${(seekSlider.value / seekSlider.max) * 100}%`
            );
            raf = requestAnimationFrame(whilePlaying);
        };

        const showRangeProgress = (rangeInput) => {
            element.style.setProperty(
                "--seek-before-width",
                (rangeInput.value / rangeInput.max) * 100 + "%"
            );
        };

        //set max and duration
        if (audioFile.readyState > 0 && seekSlider) {
            if (seekSlider) {
                setSliderMax();
                displayDuration();
            }
        } else {
            audioFile.addEventListener("loadedmetadata", () => {
                if (seekSlider) {
                    displayDuration();
                    setSliderMax();
                }
            });
        }

        //update if range changes
        if (seekSlider) {
            seekSlider.addEventListener("input", (e) => {
                currentTimeContainer.textContent = calculateTime(seekSlider.value);
                audioFile.currentTime = seekSlider.value;
                if (!audioFile.paused) {
                    requestAnimationFrame(whilePlaying);
                    cancelAnimationFrame(raf);
                }
                showRangeProgress(e.target);
            });
        }


        //play btn
        btn.addEventListener("click", () => {
            if (playState === "play") {
                audioFile.play();
                playState = "pause";
                if (seekSlider) {
                    requestAnimationFrame(whilePlaying);
                }
                gsap.to(playIcon, {
                    autoAlpha: 0,
                    duration: 0.1
                })
                gsap.to(pauseIcon, {
                    autoAlpha: 1,
                    duration: 0.1
                })
            } else {
                audioFile.pause();
                playState = "play";
                if (seekSlider) {
                    cancelAnimationFrame(raf);
                }
                gsap.to(playIcon, {
                    autoAlpha: 1,
                    duration: 0.1
                })
                gsap.to(pauseIcon, {
                    autoAlpha: 0,
                    duration: 0.1
                })
            }
        });
    });
}

export default initAudioEmbeds;